import { render, staticRenderFns } from "./ShowPraiseInfo.vue?vue&type=template&id=be8c342a&scoped=true&"
import script from "./ShowPraiseInfo.vue?vue&type=script&lang=js&"
export * from "./ShowPraiseInfo.vue?vue&type=script&lang=js&"
import style0 from "./ShowPraiseInfo.vue?vue&type=style&index=0&id=be8c342a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be8c342a",
  null
  
)

export default component.exports